<template>
  <v-main>
    <v-container class="responsive-template-content"> </v-container>
  </v-main>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
  name: "CompanyAccount",
  created() {
    this.$router.push("/company/offers");
  },
});
</script>

<style scoped></style>
